export const BACK_NAVIGATION_EXCEPTIONS = ['/payments/cancel', '/auto_signin'];
